export const PAYMASH_ENV = {
  enabledConsoleOutput: true
};
